/**
 * Read configuration that may be supplied at container runtime via
 * `window._env_` (populated by docker-entrypoint.sh) and fall back to
 * `process.env` (populated at build time / dev .env).
 */
export const getRuntimeEnv = (name, fallback = undefined) => {
  if (typeof window !== 'undefined' && window._env_ && window._env_[name] !== undefined && window._env_[name] !== '') {
    return window._env_[name];
  }
  if (typeof process !== 'undefined' && process.env && process.env[name] !== undefined && process.env[name] !== '') {
    return process.env[name];
  }
  return fallback;
};

/**
 * Dev mode unlocks demo-only affordances (scheme/demo-tenant picker, demo
 * credentials, tenant override via localStorage). Off unless REACT_APP_MODE
 * is exactly "dev".
 */
export const isDevMode = () => getRuntimeEnv('REACT_APP_MODE', 'production') === 'dev';
